export default __webpack_public_path__ + "static/media/info.af78f439.svg";